// extracted by mini-css-extract-plugin
export default {"flex":"DashboardHeader_flex__SCO93","logo":"DashboardHeader_logo__DALQj","title":"DashboardHeader_title__J0jFs"};